import { storeCreator } from '@/utils/store/store.utils';

interface State {
  primaryEmployeeId?: string;
  linkedEmployeeIds?: string[];
  handleSetPrimaryEmployeeId: (primaryEmployeeId?: string) => void;
  handleSetLinkedEmployeeIds: (linkedEmployeeIds?: string[]) => void;
  handleReset: () => void;
}

const useStore = storeCreator<State>((set) => ({
  handleSetPrimaryEmployeeId: (primaryEmployeeId) => set(() => ({ primaryEmployeeId })),
  handleSetLinkedEmployeeIds: (linkedEmployeeIds) => set(() => ({ linkedEmployeeIds })),
  handleReset: () => set(() => ({ primaryEmployeeId: undefined, linkedEmployeeIds: undefined })),
}));

const useLinkedAccountsStore = () => ({ ...useStore() });

export default useLinkedAccountsStore;
